module.exports = __webpack_public_path__ + "318a7e6cb1950fc11ca80adec9ddc024.svg";